module.exports = __webpack_public_path__ + "img/chip.c46fcab6.png";